<template>
  <card-dialog
    v-model="modalVisible"
    max-width="600px"
    :title="$t('button.filters')"
  >
    <v-card-text class="pa-6">
      <v-row
        v-for="tag in computedTags"
        :key="'filter-dialog-'+tag.id"
        align="center"
      >
        <v-col cols="4">
          {{ tag.label }}
        </v-col>
        <v-col cols="8">
          <v-select
            v-model="filtersDirty[tag.id]"
            :items="tag.items"
            :placeholder="$t('dropdown.all.placeholder')"
            dense
            outlined
            clearable
            hide-details
            @change="onTagChange(tag.id, $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4 grey-bg">
        <v-spacer />
        <v-btn
          color="primary"
          class="text-none"
          @click="applyFilters()"
        >
          {{ $t('button.apply') }}
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'TrainingExerciseFilterDialog',
  components: { CardDialog },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filtersDirty: {}
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    computedTags() {
      return this.tags.map(tag => {
        const newTag = { ...tag }
        if (newTag.filter_by) {
          if (this.filtersDirty[newTag.filter_by]) {
            newTag.items = newTag.values[this.filtersDirty[newTag.filter_by]]
          } else {
            newTag.items = []
          }
        } else {
          newTag.items = newTag.values
        }
        return newTag
      })
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.filtersDirty = cloneDeep(this.filters)

        this.tags.forEach(tag => {
          if (this.filtersDirty[tag.id] === undefined) {
            this.$set(this.filtersDirty, tag.id, undefined)
          }
        })
      }
    }
  },
  methods: {
    onTagChange(tagId, tagValue) {
      const dependingTags = this.tags.filter(tag => tag.filter_by === tagId)

      for (const tag of dependingTags) {
        if (this.filtersDirty[tag.id]) {
          this.$set(this.filtersDirty, tag.id, undefined)
          this.onTagChange(tag.id, undefined)
        }
      }
    },
    applyFilters() {
      this.$emit('update:filters', Object.keys(this.filtersDirty).reduce((acc, key) => {
        if (this.filtersDirty[key] !== undefined && this.filtersDirty[key] !== null) {
          acc[key] = this.filtersDirty[key]
        }
        return acc
      }, {}))
      this.$emit('click:apply')
      this.modalVisible = false
    }
  }
}
</script>
